(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.window = global.window || {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
            to[j] = from[i];
        return to;
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function createCommonjsModule(fn) {
      var module = { exports: {} };
    	return fn(module, module.exports), module.exports;
    }

    var browserPolyfill = createCommonjsModule(function (module) {
      (function (self) {
        (function (exports) {
          var support = {
            searchParams: 'URLSearchParams' in self,
            iterable: 'Symbol' in self && 'iterator' in Symbol,
            blob: 'FileReader' in self && 'Blob' in self && function () {
              try {
                new Blob();
                return true;
              } catch (e) {
                return false;
              }
            }(),
            formData: 'FormData' in self,
            arrayBuffer: 'ArrayBuffer' in self
          };

          function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
          }

          if (support.arrayBuffer) {
            var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

            var isArrayBufferView = ArrayBuffer.isView || function (obj) {
              return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
          }

          function normalizeName(name) {
            if (typeof name !== 'string') {
              name = String(name);
            }

            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
              throw new TypeError('Invalid character in header field name');
            }

            return name.toLowerCase();
          }

          function normalizeValue(value) {
            if (typeof value !== 'string') {
              value = String(value);
            }

            return value;
          } // Build a destructive iterator for the value list


          function iteratorFor(items) {
            var iterator = {
              next: function () {
                var value = items.shift();
                return {
                  done: value === undefined,
                  value: value
                };
              }
            };

            if (support.iterable) {
              iterator[Symbol.iterator] = function () {
                return iterator;
              };
            }

            return iterator;
          }

          function Headers(headers) {
            this.map = {};

            if (headers instanceof Headers) {
              headers.forEach(function (value, name) {
                this.append(name, value);
              }, this);
            } else if (Array.isArray(headers)) {
              headers.forEach(function (header) {
                this.append(header[0], header[1]);
              }, this);
            } else if (headers) {
              Object.getOwnPropertyNames(headers).forEach(function (name) {
                this.append(name, headers[name]);
              }, this);
            }
          }

          Headers.prototype.append = function (name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
          };

          Headers.prototype['delete'] = function (name) {
            delete this.map[normalizeName(name)];
          };

          Headers.prototype.get = function (name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
          };

          Headers.prototype.has = function (name) {
            return this.map.hasOwnProperty(normalizeName(name));
          };

          Headers.prototype.set = function (name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
          };

          Headers.prototype.forEach = function (callback, thisArg) {
            for (var name in this.map) {
              if (this.map.hasOwnProperty(name)) {
                callback.call(thisArg, this.map[name], name, this);
              }
            }
          };

          Headers.prototype.keys = function () {
            var items = [];
            this.forEach(function (value, name) {
              items.push(name);
            });
            return iteratorFor(items);
          };

          Headers.prototype.values = function () {
            var items = [];
            this.forEach(function (value) {
              items.push(value);
            });
            return iteratorFor(items);
          };

          Headers.prototype.entries = function () {
            var items = [];
            this.forEach(function (value, name) {
              items.push([name, value]);
            });
            return iteratorFor(items);
          };

          if (support.iterable) {
            Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
          }

          function consumed(body) {
            if (body.bodyUsed) {
              return Promise.reject(new TypeError('Already read'));
            }

            body.bodyUsed = true;
          }

          function fileReaderReady(reader) {
            return new Promise(function (resolve, reject) {
              reader.onload = function () {
                resolve(reader.result);
              };

              reader.onerror = function () {
                reject(reader.error);
              };
            });
          }

          function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
          }

          function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
          }

          function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);

            for (var i = 0; i < view.length; i++) {
              chars[i] = String.fromCharCode(view[i]);
            }

            return chars.join('');
          }

          function bufferClone(buf) {
            if (buf.slice) {
              return buf.slice(0);
            } else {
              var view = new Uint8Array(buf.byteLength);
              view.set(new Uint8Array(buf));
              return view.buffer;
            }
          }

          function Body() {
            this.bodyUsed = false;

            this._initBody = function (body) {
              this._bodyInit = body;

              if (!body) {
                this._bodyText = '';
              } else if (typeof body === 'string') {
                this._bodyText = body;
              } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
                this._bodyBlob = body;
              } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
                this._bodyFormData = body;
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this._bodyText = body.toString();
              } else if (support.arrayBuffer && support.blob && isDataView(body)) {
                this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.

                this._bodyInit = new Blob([this._bodyArrayBuffer]);
              } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
                this._bodyArrayBuffer = bufferClone(body);
              } else {
                this._bodyText = body = Object.prototype.toString.call(body);
              }

              if (!this.headers.get('content-type')) {
                if (typeof body === 'string') {
                  this.headers.set('content-type', 'text/plain;charset=UTF-8');
                } else if (this._bodyBlob && this._bodyBlob.type) {
                  this.headers.set('content-type', this._bodyBlob.type);
                } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                  this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
              }
            };

            if (support.blob) {
              this.blob = function () {
                var rejected = consumed(this);

                if (rejected) {
                  return rejected;
                }

                if (this._bodyBlob) {
                  return Promise.resolve(this._bodyBlob);
                } else if (this._bodyArrayBuffer) {
                  return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                } else if (this._bodyFormData) {
                  throw new Error('could not read FormData body as blob');
                } else {
                  return Promise.resolve(new Blob([this._bodyText]));
                }
              };

              this.arrayBuffer = function () {
                if (this._bodyArrayBuffer) {
                  return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                } else {
                  return this.blob().then(readBlobAsArrayBuffer);
                }
              };
            }

            this.text = function () {
              var rejected = consumed(this);

              if (rejected) {
                return rejected;
              }

              if (this._bodyBlob) {
                return readBlobAsText(this._bodyBlob);
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
              } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as text');
              } else {
                return Promise.resolve(this._bodyText);
              }
            };

            if (support.formData) {
              this.formData = function () {
                return this.text().then(decode);
              };
            }

            this.json = function () {
              return this.text().then(JSON.parse);
            };

            return this;
          } // HTTP methods whose capitalization should be normalized


          var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

          function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
          }

          function Request(input, options) {
            options = options || {};
            var body = options.body;

            if (input instanceof Request) {
              if (input.bodyUsed) {
                throw new TypeError('Already read');
              }

              this.url = input.url;
              this.credentials = input.credentials;

              if (!options.headers) {
                this.headers = new Headers(input.headers);
              }

              this.method = input.method;
              this.mode = input.mode;
              this.signal = input.signal;

              if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
              }
            } else {
              this.url = String(input);
            }

            this.credentials = options.credentials || this.credentials || 'same-origin';

            if (options.headers || !this.headers) {
              this.headers = new Headers(options.headers);
            }

            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;

            if ((this.method === 'GET' || this.method === 'HEAD') && body) {
              throw new TypeError('Body not allowed for GET or HEAD requests');
            }

            this._initBody(body);
          }

          Request.prototype.clone = function () {
            return new Request(this, {
              body: this._bodyInit
            });
          };

          function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function (bytes) {
              if (bytes) {
                var split = bytes.split('=');
                var name = split.shift().replace(/\+/g, ' ');
                var value = split.join('=').replace(/\+/g, ' ');
                form.append(decodeURIComponent(name), decodeURIComponent(value));
              }
            });
            return form;
          }

          function parseHeaders(rawHeaders) {
            var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2

            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
              var parts = line.split(':');
              var key = parts.shift().trim();

              if (key) {
                var value = parts.join(':').trim();
                headers.append(key, value);
              }
            });
            return headers;
          }

          Body.call(Request.prototype);

          function Response(bodyInit, options) {
            if (!options) {
              options = {};
            }

            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';

            this._initBody(bodyInit);
          }

          Body.call(Response.prototype);

          Response.prototype.clone = function () {
            return new Response(this._bodyInit, {
              status: this.status,
              statusText: this.statusText,
              headers: new Headers(this.headers),
              url: this.url
            });
          };

          Response.error = function () {
            var response = new Response(null, {
              status: 0,
              statusText: ''
            });
            response.type = 'error';
            return response;
          };

          var redirectStatuses = [301, 302, 303, 307, 308];

          Response.redirect = function (url, status) {
            if (redirectStatuses.indexOf(status) === -1) {
              throw new RangeError('Invalid status code');
            }

            return new Response(null, {
              status: status,
              headers: {
                location: url
              }
            });
          };

          exports.DOMException = self.DOMException;

          try {
            new exports.DOMException();
          } catch (err) {
            exports.DOMException = function (message, name) {
              this.message = message;
              this.name = name;
              var error = Error(message);
              this.stack = error.stack;
            };

            exports.DOMException.prototype = Object.create(Error.prototype);
            exports.DOMException.prototype.constructor = exports.DOMException;
          }

          function fetch(input, init) {
            return new Promise(function (resolve, reject) {
              var request = new Request(input, init);

              if (request.signal && request.signal.aborted) {
                return reject(new exports.DOMException('Aborted', 'AbortError'));
              }

              var xhr = new XMLHttpRequest();

              function abortXhr() {
                xhr.abort();
              }

              xhr.onload = function () {
                var options = {
                  status: xhr.status,
                  statusText: xhr.statusText,
                  headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                };
                options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                var body = 'response' in xhr ? xhr.response : xhr.responseText;
                resolve(new Response(body, options));
              };

              xhr.onerror = function () {
                reject(new TypeError('Network request failed'));
              };

              xhr.ontimeout = function () {
                reject(new TypeError('Network request failed'));
              };

              xhr.onabort = function () {
                reject(new exports.DOMException('Aborted', 'AbortError'));
              };

              xhr.open(request.method, request.url, true);

              if (request.credentials === 'include') {
                xhr.withCredentials = true;
              } else if (request.credentials === 'omit') {
                xhr.withCredentials = false;
              }

              if ('responseType' in xhr && support.blob) {
                xhr.responseType = 'blob';
              }

              request.headers.forEach(function (value, name) {
                xhr.setRequestHeader(name, value);
              });

              if (request.signal) {
                request.signal.addEventListener('abort', abortXhr);

                xhr.onreadystatechange = function () {
                  // DONE (success or failure)
                  if (xhr.readyState === 4) {
                    request.signal.removeEventListener('abort', abortXhr);
                  }
                };
              }

              xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
          }

          fetch.polyfill = true;

          if (!self.fetch) {
            self.fetch = fetch;
            self.Headers = Headers;
            self.Request = Request;
            self.Response = Response;
          }

          exports.Headers = Headers;
          exports.Request = Request;
          exports.Response = Response;
          exports.fetch = fetch;
          Object.defineProperty(exports, '__esModule', {
            value: true
          });
          return exports;
        })({});
      })(typeof self !== 'undefined' ? self : commonjsGlobal);
    });

    var meilisearch_umd = createCommonjsModule(function (module, exports) {
      (function (global, factory) {
        factory(exports, browserPolyfill) ;
      })(commonjsGlobal, function (exports) {
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation.
          Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */

        /* global Reflect, Promise */

        var extendStatics = function (d, b) {
          extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
          };

          return extendStatics(d, b);
        };

        function __extends(d, b) {
          if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        }

        var __assign = function () {
          __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        function __awaiter(thisArg, _arguments, P, generator) {
          function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
              resolve(value);
            });
          }

          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }

            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }

            function step(result) {
              result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }

            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }

        function __generator(thisArg, body) {
          var _ = {
            label: 0,
            sent: function () {
              if (t[0] & 1) throw t[1];
              return t[1];
            },
            trys: [],
            ops: []
          },
              f,
              y,
              t,
              g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;

          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }

          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");

            while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];

              switch (op[0]) {
                case 0:
                case 1:
                  t = op;
                  break;

                case 4:
                  _.label++;
                  return {
                    value: op[1],
                    done: false
                  };

                case 5:
                  _.label++;
                  y = op[1];
                  op = [0];
                  continue;

                case 7:
                  op = _.ops.pop();

                  _.trys.pop();

                  continue;

                default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                  }

                  if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                  }

                  if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                  }

                  if (t && _.label < t[2]) {
                    _.label = t[2];

                    _.ops.push(op);

                    break;
                  }

                  if (t[2]) _.ops.pop();

                  _.trys.pop();

                  continue;
              }

              op = body.call(thisArg, _);
            } catch (e) {
              op = [6, e];
              y = 0;
            } finally {
              f = t = 0;
            }

            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        }

        var MeiliSearchCommunicationError =
        /** @class */
        function (_super) {
          __extends(MeiliSearchCommunicationError, _super);

          function MeiliSearchCommunicationError(message, body) {
            var _this = _super.call(this, message) || this;

            _this.name = 'MeiliSearchCommunicationError';
            _this.type = 'MeiliSearchCommunicationError';

            if (body instanceof Response) {
              _this.message = body.statusText;
              _this.statusCode = body.status;
            }

            if (body instanceof Error) {
              _this.errno = body.errno;
              _this.code = body.code;
            }

            if (Error.captureStackTrace) {
              Error.captureStackTrace(_this, MeiliSearchCommunicationError);
            }

            return _this;
          }

          return MeiliSearchCommunicationError;
        }(Error);

        var MeiliSearchApiError =
        /** @class */
        function (_super) {
          __extends(class_1, _super);

          function class_1(error, status) {
            var _this = _super.call(this, error.message) || this;

            _this.type = 'MeiliSearchApiError';
            _this.name = 'MeiliSearchApiError';
            _this.errorCode = error.errorCode;
            _this.errorType = error.errorType;
            _this.errorLink = error.errorLink;
            _this.message = error.message;
            _this.httpStatus = status;
            return _this;
          }

          return class_1;
        }(Error);

        function httpResponseErrorHandler(response) {
          return __awaiter(this, void 0, void 0, function () {
            var err;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  if (!!response.ok) return [3
                  /*break*/
                  , 5];
                  err = void 0;
                  _a.label = 1;

                case 1:
                  _a.trys.push([1, 3,, 4]);

                  return [4
                  /*yield*/
                  , response.json()];

                case 2:
                  err = _a.sent();
                  return [3
                  /*break*/
                  , 4];

                case 3:
                  _a.sent();

                  throw new MeiliSearchCommunicationError(response.statusText, response);

                case 4:
                  throw new MeiliSearchApiError(err, response.status);

                case 5:
                  return [2
                  /*return*/
                  , response];
              }
            });
          });
        }

        function httpErrorHandler(response) {
          if (response.type !== 'MeiliSearchApiError') {
            throw new MeiliSearchCommunicationError(response.message, response);
          }

          throw response;
        }

        var MeiliSearchError =
        /** @class */
        function (_super) {
          __extends(MeiliSearchError, _super);

          function MeiliSearchError(message) {
            var _this = _super.call(this, message) || this;

            _this.name = 'MeiliSearchError';
            _this.type = 'MeiliSearchError';

            if (Error.captureStackTrace) {
              Error.captureStackTrace(_this, MeiliSearchError);
            }

            return _this;
          }

          return MeiliSearchError;
        }(Error);

        var MeiliSearchTimeOutError =
        /** @class */
        function (_super) {
          __extends(MeiliSearchTimeOutError, _super);

          function MeiliSearchTimeOutError(message) {
            var _this = _super.call(this, message) || this;

            _this.name = 'MeiliSearchTimeOutError';
            _this.type = _this.constructor.name;

            if (Error.captureStackTrace) {
              Error.captureStackTrace(_this, MeiliSearchTimeOutError);
            }

            return _this;
          }

          return MeiliSearchTimeOutError;
        }(Error);

        var HttpRequests =
        /** @class */
        function () {
          function HttpRequests(config) {
            this.headers = __assign(__assign(__assign({}, config.headers || {}), {
              'Content-Type': 'application/json'
            }), config.apiKey ? {
              'X-Meili-API-Key': config.apiKey
            } : {});
            this.url = new URL(config.host);
          }

          HttpRequests.addTrailingSlash = function (url) {
            if (!url.endsWith('/')) {
              url += '/';
            }

            return url;
          };

          HttpRequests.prototype.request = function (_a) {
            var method = _a.method,
                url = _a.url,
                params = _a.params,
                body = _a.body,
                config = _a.config;
            return __awaiter(this, void 0, void 0, function () {
              var constructURL, queryParams_1, response, parsedBody, parsedJson, e_1;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    _b.trys.push([0, 3,, 4]);

                    constructURL = new URL(url, this.url);

                    if (params) {
                      queryParams_1 = new URLSearchParams();
                      Object.keys(params).filter(function (x) {
                        return params[x] !== null;
                      }).map(function (x) {
                        return queryParams_1.set(x, params[x]);
                      });
                      constructURL.search = queryParams_1.toString();
                    }

                    return [4
                    /*yield*/
                    , fetch(constructURL.toString(), __assign(__assign({}, config), {
                      method: method,
                      body: JSON.stringify(body),
                      headers: this.headers
                    })).then(function (res) {
                      return httpResponseErrorHandler(res);
                    })];

                  case 1:
                    response = _b.sent();
                    return [4
                    /*yield*/
                    , response.text()];

                  case 2:
                    parsedBody = _b.sent();

                    try {
                      parsedJson = JSON.parse(parsedBody);
                      return [2
                      /*return*/
                      , parsedJson];
                    } catch (_) {
                      return [2
                      /*return*/
                      ];
                    }

                    return [3
                    /*break*/
                    , 4];

                  case 3:
                    e_1 = _b.sent();
                    httpErrorHandler(e_1);
                    return [3
                    /*break*/
                    , 4];

                  case 4:
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          };

          HttpRequests.prototype.get = function (url, params, config) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , this.request({
                      method: 'GET',
                      url: url,
                      params: params,
                      config: config
                    })];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };

          HttpRequests.prototype.post = function (url, data, params, config) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , this.request({
                      method: 'POST',
                      url: url,
                      body: data,
                      params: params,
                      config: config
                    })];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };

          HttpRequests.prototype.put = function (url, data, params, config) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , this.request({
                      method: 'PUT',
                      url: url,
                      body: data,
                      params: params,
                      config: config
                    })];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };

          HttpRequests.prototype["delete"] = function (url, data, params, config) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , this.request({
                      method: 'DELETE',
                      url: url,
                      body: data,
                      params: params,
                      config: config
                    })];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };

          return HttpRequests;
        }();
        /**
         * Removes undefined entries from object
         */


        function removeUndefinedFromObject(obj) {
          return Object.entries(obj).reduce(function (acc, curEntry) {
            var key = curEntry[0],
                val = curEntry[1];
            if (val !== undefined) acc[key] = val;
            return acc;
          }, {});
        }

        function sleep(ms) {
          return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4
                  /*yield*/
                  , new Promise(function (resolve) {
                    return setTimeout(resolve, ms);
                  })];

                case 1:
                  return [2
                  /*return*/
                  , _a.sent()];
              }
            });
          });
        }
        /*
         * Bundle: MeiliSearch / Indexes
         * Project: MeiliSearch - Javascript API
         * Author: Quentin de Quelen <quentin@meilisearch.com>
         * Copyright: 2019, MeiliSearch
         */


        var Index =
        /** @class */
        function () {
          function Index(config, uid, primaryKey) {
            this.uid = uid;
            this.primaryKey = primaryKey;
            this.httpRequest = new HttpRequests(config);
          } ///
          /// UTILS
          ///


          Index.prototype.waitForPendingUpdate = function (updateId, _a) {
            var _b = _a === void 0 ? {} : _a,
                _c = _b.timeOutMs,
                timeOutMs = _c === void 0 ? 5000 : _c,
                _d = _b.intervalMs,
                intervalMs = _d === void 0 ? 50 : _d;

            return __awaiter(this, void 0, void 0, function () {
              var startingTime, response;
              return __generator(this, function (_e) {
                switch (_e.label) {
                  case 0:
                    startingTime = Date.now();
                    _e.label = 1;

                  case 1:
                    if (!(Date.now() - startingTime < timeOutMs)) return [3
                    /*break*/
                    , 4];
                    return [4
                    /*yield*/
                    , this.getUpdateStatus(updateId)];

                  case 2:
                    response = _e.sent();
                    if (!['enqueued', 'processing'].includes(response.status)) return [2
                    /*return*/
                    , response];
                    return [4
                    /*yield*/
                    , sleep(intervalMs)];

                  case 3:
                    _e.sent();

                    return [3
                    /*break*/
                    , 1];

                  case 4:
                    throw new MeiliSearchTimeOutError("timeout of " + timeOutMs + "ms has exceeded on process " + updateId + " when waiting for pending update to resolve.");
                }
              });
            });
          }; ///
          /// SEARCH
          ///

          /**
           * Search for documents into an index
           * @memberof Index
           * @method search
           */


          Index.prototype.search = function (query, options, config) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/search";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, removeUndefinedFromObject(__assign(__assign({}, options), {
                      q: query
                    })), undefined, config)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Search for documents into an index using the GET method
           * @memberof Index
           * @method search
           */


          Index.prototype.searchGet = function (query, options, config) {
            return __awaiter(this, void 0, void 0, function () {
              var url, parseFilter, getParams;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/search";

                    parseFilter = function parseFilter(filter) {
                      if (typeof filter === 'string') return filter;else if (Array.isArray(filter)) throw new MeiliSearchError('The filter query parameter should be in string format when using searchGet');else return undefined;
                    };

                    getParams = __assign(__assign({
                      q: query
                    }, options), {
                      filter: parseFilter(options === null || options === void 0 ? void 0 : options.filter),
                      sort: (options === null || options === void 0 ? void 0 : options.sort) ? options.sort.join(',') : undefined,
                      facetsDistribution: (options === null || options === void 0 ? void 0 : options.facetsDistribution) ? options.facetsDistribution.join(',') : undefined,
                      attributesToRetrieve: (options === null || options === void 0 ? void 0 : options.attributesToRetrieve) ? options.attributesToRetrieve.join(',') : undefined,
                      attributesToCrop: (options === null || options === void 0 ? void 0 : options.attributesToCrop) ? options.attributesToCrop.join(',') : undefined,
                      attributesToHighlight: (options === null || options === void 0 ? void 0 : options.attributesToHighlight) ? options.attributesToHighlight.join(',') : undefined
                    });
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url, removeUndefinedFromObject(getParams), config)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// INDEX
          ///

          /**
           * Get index information.
           * @memberof Index
           * @method getRawInfo
           */


          Index.prototype.getRawInfo = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url, res;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid;
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    res = _a.sent();
                    this.primaryKey = res.primaryKey;
                    return [2
                    /*return*/
                    , res];
                }
              });
            });
          };
          /**
           * Fetch and update Index information.
           * @memberof Index
           * @method fetchInfo
           */


          Index.prototype.fetchInfo = function () {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , this.getRawInfo()];

                  case 1:
                    _a.sent();

                    return [2
                    /*return*/
                    , this];
                }
              });
            });
          };
          /**
           * Get Primary Key.
           * @memberof Index
           * @method fetchPrimaryKey
           */


          Index.prototype.fetchPrimaryKey = function () {
            return __awaiter(this, void 0, void 0, function () {
              var _a;

              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    _a = this;
                    return [4
                    /*yield*/
                    , this.getRawInfo()];

                  case 1:
                    _a.primaryKey = _b.sent().primaryKey;
                    return [2
                    /*return*/
                    , this.primaryKey];
                }
              });
            });
          };
          /**
           * Create an index.
           * @memberof Index
           * @method create
           */


          Index.create = function (config, uid, options) {
            if (options === void 0) {
              options = {};
            }

            return __awaiter(this, void 0, void 0, function () {
              var url, req, index;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes";
                    req = new HttpRequests(config);
                    return [4
                    /*yield*/
                    , req.post(url, __assign(__assign({}, options), {
                      uid: uid
                    }))];

                  case 1:
                    index = _a.sent();
                    return [2
                    /*return*/
                    , new Index(config, uid, index.primaryKey)];
                }
              });
            });
          };
          /**
           * Update an index.
           * @memberof Index
           * @method update
           */


          Index.prototype.update = function (data) {
            return __awaiter(this, void 0, void 0, function () {
              var url, index;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid;
                    return [4
                    /*yield*/
                    , this.httpRequest.put(url, data)];

                  case 1:
                    index = _a.sent();
                    this.primaryKey = index.primaryKey;
                    return [2
                    /*return*/
                    , this];
                }
              });
            });
          };
          /**
           * Delete an index.
           * @memberof Index
           * @method delete
           */


          Index.prototype["delete"] = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid;
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Deletes an index if it already exists.
           * @memberof Index
           * @method deleteIfExists
           */


          Index.prototype.deleteIfExists = function () {
            return __awaiter(this, void 0, void 0, function () {
              var e_1;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);

                    return [4
                    /*yield*/
                    , this["delete"]()];

                  case 1:
                    _a.sent();

                    return [2
                    /*return*/
                    , true];

                  case 2:
                    e_1 = _a.sent();

                    if (e_1.errorCode === 'index_not_found') {
                      return [2
                      /*return*/
                      , false];
                    }

                    throw e_1;

                  case 3:
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          }; ///
          /// UPDATES
          ///

          /**
           * Get the list of all updates
           * @memberof Index
           * @method getAllUpdateStatus
           */


          Index.prototype.getAllUpdateStatus = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/updates";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Get the informations about an update status
           * @memberof Index
           * @method getUpdateStatus
           */


          Index.prototype.getUpdateStatus = function (updateId) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/updates/" + updateId;
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// STATS
          ///

          /**
           * get stats of an index
           * @memberof Index
           * @method getStats
           */


          Index.prototype.getStats = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/stats";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// DOCUMENTS
          ///

          /**
           * get documents of an index
           * @memberof Index
           * @method getDocuments
           */


          Index.prototype.getDocuments = function (options) {
            return __awaiter(this, void 0, void 0, function () {
              var url, attr;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/documents";

                    if (options !== undefined && Array.isArray(options.attributesToRetrieve)) {
                      attr = options.attributesToRetrieve.join(',');
                    }

                    return [4
                    /*yield*/
                    , this.httpRequest.get(url, __assign(__assign({}, options), attr !== undefined ? {
                      attributesToRetrieve: attr
                    } : {}))];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Get one document
           * @memberof Index
           * @method getDocument
           */


          Index.prototype.getDocument = function (documentId) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/documents/" + documentId;
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Add or replace multiples documents to an index
           * @memberof Index
           * @method addDocuments
           */


          Index.prototype.addDocuments = function (documents, options) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/documents";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, documents, options)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Add or update multiples documents to an index
           * @memberof Index
           * @method updateDocuments
           */


          Index.prototype.updateDocuments = function (documents, options) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/documents";
                    return [4
                    /*yield*/
                    , this.httpRequest.put(url, documents, options)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Delete one document
           * @memberof Index
           * @method deleteDocument
           */


          Index.prototype.deleteDocument = function (documentId) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/documents/" + documentId;
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Delete multiples documents of an index
           * @memberof Index
           * @method deleteDocuments
           */


          Index.prototype.deleteDocuments = function (documentsIds) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/documents/delete-batch";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, documentsIds)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Delete all documents of an index
           * @memberof Index
           * @method deleteAllDocuments
           */


          Index.prototype.deleteAllDocuments = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/documents";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// SETTINGS
          ///

          /**
           * Retrieve all settings
           * @memberof Index
           * @method getSettings
           */


          Index.prototype.getSettings = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update all settings
           * Any parameters not provided will be left unchanged.
           * @memberof Index
           * @method updateSettings
           */


          Index.prototype.updateSettings = function (settings) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, settings)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset settings.
           * @memberof Index
           * @method resetSettings
           */


          Index.prototype.resetSettings = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// SYNONYMS
          ///

          /**
           * Get the list of all synonyms
           * @memberof Index
           * @method getSynonyms
           */


          Index.prototype.getSynonyms = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/synonyms";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the list of synonyms. Overwrite the old list.
           * @memberof Index
           * @method updateSynonyms
           */


          Index.prototype.updateSynonyms = function (synonyms) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/synonyms";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, synonyms)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the synonym list to be empty again
           * @memberof Index
           * @method resetSynonyms
           */


          Index.prototype.resetSynonyms = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/synonyms";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// STOP WORDS
          ///

          /**
           * Get the list of all stop-words
           * @memberof Index
           * @method getStopWords
           */


          Index.prototype.getStopWords = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/stop-words";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the list of stop-words. Overwrite the old list.
           * @memberof Index
           * @method updateStopWords
           */


          Index.prototype.updateStopWords = function (stopWords) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/stop-words";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, stopWords)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the stop-words list to be empty again
           * @memberof Index
           * @method resetStopWords
           */


          Index.prototype.resetStopWords = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/stop-words";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// RANKING RULES
          ///

          /**
           * Get the list of all ranking-rules
           * @memberof Index
           * @method getRankingRules
           */


          Index.prototype.getRankingRules = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/ranking-rules";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the list of ranking-rules. Overwrite the old list.
           * @memberof Index
           * @method updateRankingRules
           */


          Index.prototype.updateRankingRules = function (rankingRules) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/ranking-rules";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, rankingRules)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the ranking rules list to its default value
           * @memberof Index
           * @method resetRankingRules
           */


          Index.prototype.resetRankingRules = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/ranking-rules";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// DISTINCT ATTRIBUTE
          ///

          /**
           * Get the distinct-attribute
           * @memberof Index
           * @method getDistinctAttribute
           */


          Index.prototype.getDistinctAttribute = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/distinct-attribute";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the distinct-attribute.
           * @memberof Index
           * @method updateDistinctAttribute
           */


          Index.prototype.updateDistinctAttribute = function (distinctAttribute) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/distinct-attribute";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, distinctAttribute)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the distinct-attribute.
           * @memberof Index
           * @method resetDistinctAttribute
           */


          Index.prototype.resetDistinctAttribute = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/distinct-attribute";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// FILTERABLE ATTRIBUTES
          ///

          /**
           * Get the filterable-attributes
           * @memberof Index
           * @method getFilterableAttributes
           */


          Index.prototype.getFilterableAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/filterable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the filterable-attributes.
           * @memberof Index
           * @method updateFilterableAttributes
           */


          Index.prototype.updateFilterableAttributes = function (filterableAttributes) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/filterable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, filterableAttributes)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the filterable-attributes.
           * @memberof Index
           * @method resetFilterableAttributes
           */


          Index.prototype.resetFilterableAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/filterable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// SORTABLE ATTRIBUTES
          ///

          /**
           * Get the sortable-attributes
           * @memberof Index
           * @method getSortableAttributes
           */


          Index.prototype.getSortableAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/sortable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the sortable-attributes.
           * @memberof Index
           * @method updateSortableAttributes
           */


          Index.prototype.updateSortableAttributes = function (sortableAttributes) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/sortable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, sortableAttributes)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the sortable-attributes.
           * @memberof Index
           * @method resetSortableAttributes
           */


          Index.prototype.resetSortableAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/sortable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// SEARCHABLE ATTRIBUTE
          ///

          /**
           * Get the searchable-attributes
           * @memberof Index
           * @method getSearchableAttributes
           */


          Index.prototype.getSearchableAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/searchable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the searchable-attributes.
           * @memberof Index
           * @method updateSearchableAttributes
           */


          Index.prototype.updateSearchableAttributes = function (searchableAttributes) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/searchable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, searchableAttributes)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the searchable-attributes.
           * @memberof Index
           * @method resetSearchableAttributes
           */


          Index.prototype.resetSearchableAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/searchable-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// DISPLAYED ATTRIBUTE
          ///

          /**
           * Get the displayed-attributes
           * @memberof Index
           * @method getDisplayedAttributes
           */


          Index.prototype.getDisplayedAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/displayed-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update the displayed-attributes.
           * @memberof Index
           * @method updateDisplayedAttributes
           */


          Index.prototype.updateDisplayedAttributes = function (displayedAttributes) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/displayed-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url, displayedAttributes)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Reset the displayed-attributes.
           * @memberof Index
           * @method resetDisplayedAttributes
           */


          Index.prototype.resetDisplayedAttributes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes/" + this.uid + "/settings/displayed-attributes";
                    return [4
                    /*yield*/
                    , this.httpRequest["delete"](url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };

          return Index;
        }();
        /*
         * Bundle: MeiliSearch
         * Project: MeiliSearch - Javascript API
         * Author: Quentin de Quelen <quentin@meilisearch.com>
         * Copyright: 2019, MeiliSearch
         */


        var MeiliSearch =
        /** @class */
        function () {
          function MeiliSearch(config) {
            config.host = HttpRequests.addTrailingSlash(config.host);
            this.config = config;
            this.httpRequest = new HttpRequests(config);
          }
          /**
           * Return an Index instance
           * @memberof MeiliSearch
           * @method index
           */


          MeiliSearch.prototype.index = function (indexUid) {
            return new Index(this.config, indexUid);
          };
          /**
           * Gather information about an index by calling MeiliSearch and
           * return an Index instance with the gathered information
           * @memberof MeiliSearch
           * @method getIndex
           */


          MeiliSearch.prototype.getIndex = function (indexUid) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2
                /*return*/
                , new Index(this.config, indexUid).fetchInfo()];
              });
            });
          };
          /**
           * Get an index or create it if it does not exist
           * @memberof MeiliSearch
           * @method getOrCreateIndex
           */


          MeiliSearch.prototype.getOrCreateIndex = function (uid, options) {
            if (options === void 0) {
              options = {};
            }

            return __awaiter(this, void 0, void 0, function () {
              var index, e_1;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);

                    return [4
                    /*yield*/
                    , this.getIndex(uid)];

                  case 1:
                    index = _a.sent();
                    return [2
                    /*return*/
                    , index];

                  case 2:
                    e_1 = _a.sent();

                    if (e_1.errorCode === 'index_not_found') {
                      return [2
                      /*return*/
                      , this.createIndex(uid, options)];
                    }

                    throw new MeiliSearchApiError(e_1, e_1.status);

                  case 3:
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          };
          /**
           * List all indexes in the database
           * @memberof MeiliSearch
           * @method listIndexes
           */


          MeiliSearch.prototype.listIndexes = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "indexes";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Create a new index
           * @memberof MeiliSearch
           * @method createIndex
           */


          MeiliSearch.prototype.createIndex = function (uid, options) {
            if (options === void 0) {
              options = {};
            }

            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , Index.create(this.config, uid, options)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Update an index
           * @memberof MeiliSearch
           * @method updateIndex
           */


          MeiliSearch.prototype.updateIndex = function (uid, options) {
            if (options === void 0) {
              options = {};
            }

            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2
                /*return*/
                , new Index(this.config, uid).update(options)];
              });
            });
          };
          /**
           * Delete an index
           * @memberof MeiliSearch
           * @method deleteIndex
           */


          MeiliSearch.prototype.deleteIndex = function (uid) {
            return __awaiter(this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                return [2
                /*return*/
                , new Index(this.config, uid)["delete"]()];
              });
            });
          };
          /**
           * Deletes an index if it already exists.
           * @memberof MeiliSearch
           * @method deleteIndexIfExists
           */


          MeiliSearch.prototype.deleteIndexIfExists = function (uid) {
            return __awaiter(this, void 0, void 0, function () {
              var e_2;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);

                    return [4
                    /*yield*/
                    , this.deleteIndex(uid)];

                  case 1:
                    _a.sent();

                    return [2
                    /*return*/
                    , true];

                  case 2:
                    e_2 = _a.sent();

                    if (e_2.errorCode === 'index_not_found') {
                      return [2
                      /*return*/
                      , false];
                    }

                    throw e_2;

                  case 3:
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          }; ///
          /// KEYS
          ///

          /**
           * Get private and public key
           * @memberof MeiliSearch
           * @method getKey
           */


          MeiliSearch.prototype.getKeys = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "keys";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// HEALTH
          ///

          /**
           * Checks if the server is healthy, otherwise an error will be thrown.
           *
           * @memberof MeiliSearch
           * @method health
           */


          MeiliSearch.prototype.health = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "health";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Checks if the server is healthy, return true or false.
           *
           * @memberof MeiliSearch
           * @method isHealthy
           */


          MeiliSearch.prototype.isHealthy = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);

                    url = "health";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    _a.sent();

                    return [2
                    /*return*/
                    , true];

                  case 2:
                    _a.sent();

                    return [2
                    /*return*/
                    , false];

                  case 3:
                    return [2
                    /*return*/
                    ];
                }
              });
            });
          }; ///
          /// STATS
          ///

          /**
           * Get the stats of all the database
           * @memberof MeiliSearch
           * @method stats
           */


          MeiliSearch.prototype.stats = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "stats";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// VERSION
          ///

          /**
           * Get the version of MeiliSearch
           * @memberof MeiliSearch
           * @method version
           */


          MeiliSearch.prototype.version = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "version";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          }; ///
          /// DUMPS
          ///

          /**
           * Triggers a dump creation process
           * @memberof MeiliSearch
           * @method createDump
           */


          MeiliSearch.prototype.createDump = function () {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "dumps";
                    return [4
                    /*yield*/
                    , this.httpRequest.post(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };
          /**
           * Get the status of a dump creation process
           * @memberof MeiliSearch
           * @method getDumpStatus
           */


          MeiliSearch.prototype.getDumpStatus = function (dumpUid) {
            return __awaiter(this, void 0, void 0, function () {
              var url;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    url = "dumps/" + dumpUid + "/status";
                    return [4
                    /*yield*/
                    , this.httpRequest.get(url)];

                  case 1:
                    return [2
                    /*return*/
                    , _a.sent()];
                }
              });
            });
          };

          return MeiliSearch;
        }();

        exports.HttpRequests = HttpRequests;
        exports.Index = Index;
        exports.MeiliSearch = MeiliSearch;
        exports.MeiliSearchApiError = MeiliSearchApiError;
        exports.MeiliSearchCommunicationError = MeiliSearchCommunicationError;
        exports.MeiliSearchError = MeiliSearchError;
        exports.MeiliSearchTimeOutError = MeiliSearchTimeOutError;
        exports["default"] = MeiliSearch;
        exports.httpErrorHandler = httpErrorHandler;
        exports.httpResponseErrorHandler = httpResponseErrorHandler;
        exports.removeUndefinedFromObject = removeUndefinedFromObject;
        exports.sleep = sleep;
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
      });
    });

    var removeUndefined = function (arr) {
        return arr.filter(function (x) { return x !== undefined; });
    };

    /**
     * @param  {any} str
     * @returns boolean
     */
    function isString(str) {
        return typeof str === 'string' || str instanceof String;
    }
    /**
     * @param  {string} filter
     * @returns string
     */
    function replaceColonByEqualSign(filter) {
        // will only change first occurence of `:`
        return filter.replace(/:(.*)/i, '="$1"');
    }

    /**
     * @param  {number} dividend
     * @param  {number} divisor
     * @returns number
     */
    function ceiledDivision(dividend, divisor) {
        if (divisor > 0) {
            var NumberPages = Math.ceil(dividend / divisor); // total number of pages rounded up to the next largest integer.
            return NumberPages;
        }
        return 0;
    }

    /**
     * Transform InstantSearch filter to MeiliSearch filter.
     * Change sign from `:` to `=` in nested filter object.
     * example: [`genres:comedy`] becomes [`genres=comedy`]
     *
     * @param  {AlgoliaSearchOptions['facetFilters']} filters?
     * @returns Filter
     */
    function transformFilter(filters) {
        if (typeof filters === 'string') {
            return replaceColonByEqualSign(filters);
        }
        else if (Array.isArray(filters))
            return filters
                .map(function (filter) {
                if (Array.isArray(filter))
                    return filter
                        .map(function (nestedFilter) { return replaceColonByEqualSign(nestedFilter); })
                        .filter(function (elem) { return elem; });
                else {
                    return replaceColonByEqualSign(filter);
                }
            })
                .filter(function (elem) { return elem; });
        return [];
    }
    /**
     * Return the filter in an array if it is a string
     * If filter is array, return without change.
     *
     * @param  {Filter} filter
     * @returns Array
     */
    function filterToArray(filter) {
        // Filter is a string
        if (filter === '')
            return [];
        else if (typeof filter === 'string')
            return [filter];
        // Filter is either an array of strings, or an array of array of strings
        return filter;
    }
    /**
     * Merge facetFilters, numericFilters and filters together.
     *
     * @param  {Filter} facetFilters
     * @param  {Filter} numericFilters
     * @param  {string} filters
     * @returns Filter
     */
    function mergeFilters(facetFilters, numericFilters, filters) {
        var adaptedFilters = filters.trim();
        var adaptedFacetFilters = filterToArray(facetFilters);
        var adaptedNumericFilters = filterToArray(numericFilters);
        var adaptedFilter = __spreadArray(__spreadArray(__spreadArray([], adaptedFacetFilters, true), adaptedNumericFilters, true), [
            adaptedFilters,
        ]);
        var cleanedFilters = adaptedFilter.filter(function (filter) {
            if (Array.isArray(filter)) {
                return filter.length;
            }
            return filter;
        });
        return cleanedFilters;
    }
    /**
     * Adapt instantsearch.js filters to MeiliSearch filters by
     * combining and transforming all provided filters.
     *
     * @param  {string|undefined} filters
     * @param  {AlgoliaSearchOptions['numericFilters']} numericFilters
     * @param  {AlgoliaSearchOptions['facetFilters']} facetFilters
     * @returns Filter
     */
    function adaptFilters(filters, numericFilters, facetFilters) {
        var transformedFilter = transformFilter(facetFilters || []);
        var transformedNumericFilter = transformFilter(numericFilters || []);
        return mergeFilters(transformedFilter, transformedNumericFilter, filters || '');
    }

    /**
     * Adapt search request from instantsearch.js
     * to search request compliant with MeiliSearch
     *
     * @param  {InstantSearchParams} instantSearchParams
     * @param  {number} paginationTotalHits
     * @param  {boolean} placeholderSearch
     * @param  {string} sort?
     * @param  {string} query?
     * @returns MeiliSearchParams
     */
    function adaptSearchRequest(instantSearchParams, paginationTotalHits, placeholderSearch, sort, query) {
        // Creates search params object compliant with MeiliSearch
        var meiliSearchParams = {};
        // Facets
        var facets = instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.facets;
        if (facets === null || facets === void 0 ? void 0 : facets.length) {
            meiliSearchParams.facetsDistribution = facets;
        }
        // Attributes To Crop
        var attributesToCrop = instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.attributesToSnippet;
        if (attributesToCrop) {
            meiliSearchParams.attributesToCrop = attributesToCrop;
        }
        // Attributes To Retrieve
        var attributesToRetrieve = instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.attributesToRetrieve;
        if (attributesToRetrieve) {
            meiliSearchParams.attributesToRetrieve = attributesToRetrieve;
        }
        // Filter
        var filter = adaptFilters(instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.filters, instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.numericFilters, instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.facetFilters);
        if (filter.length) {
            meiliSearchParams.filter = filter;
        }
        // Attributes To Retrieve
        if (attributesToRetrieve) {
            meiliSearchParams.attributesToCrop = attributesToRetrieve;
        }
        // Attributes To Highlight
        meiliSearchParams.attributesToHighlight = (instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.attributesToHighlight) || [
            '*',
        ];
        if ((!placeholderSearch && query === '') || paginationTotalHits === 0) {
            meiliSearchParams.limit = 0;
        }
        else {
            meiliSearchParams.limit = paginationTotalHits;
        }
        // Sort
        if (sort === null || sort === void 0 ? void 0 : sort.length) {
            meiliSearchParams.sort = [sort];
        }
        return meiliSearchParams;
    }

    /**
     * Slice the requested hits based on the pagination position.
     *
     * @param  {Record<string} hits
     * @param  {number} page
     * @param  {number} hitsPerPage
     * @returns Array
     */
    function adaptPagination(hits, page, hitsPerPage) {
        var start = page * hitsPerPage;
        return hits.splice(start, hitsPerPage);
    }

    /**
     * Replace `em` tags in highlighted MeiliSearch hits to
     * provided tags by instantsearch.js.
     *
     * @param  {string} value
     * @param  {string} highlightPreTag?
     * @param  {string} highlightPostTag?
     * @returns string
     */
    function replaceHighlightTags(value, highlightPreTag, highlightPostTag) {
        highlightPreTag = highlightPreTag || '__ais-highlight__';
        highlightPostTag = highlightPostTag || '__/ais-highlight__';
        // Highlight is applied by MeiliSearch (<em> tags)
        // We replace the <em> by the expected tag for InstantSearch
        var stringifiedValue = isString(value)
            ? value
            : JSON.stringify(value, null, 2);
        return stringifiedValue
            .replace(/<em>/g, highlightPreTag)
            .replace(/<\/em>/g, highlightPostTag);
    }
    /**
     * @param  {Record<string} formattedHit
     * @param  {string} highlightPreTag?
     * @param  {string} highlightPostTag?
     * @returns Record
     */
    function adaptHighlight(formattedHit, highlightPreTag, highlightPostTag) {
        // formattedHit is the `_formatted` object returned by MeiliSearch.
        // It contains all the highlighted and croped attributes
        return Object.keys(formattedHit).reduce(function (result, key) {
            result[key] = {
                value: replaceHighlightTags(formattedHit[key], highlightPreTag, highlightPostTag),
            };
            return result;
        }, {});
    }
    /**
     * @param  {string} value
     * @param  {string} snippetEllipsisText?
     * @param  {string} highlightPreTag?
     * @param  {string} highlightPostTag?
     * @returns string
     */
    function snippetValue(value, snippetEllipsisText, highlightPreTag, highlightPostTag) {
        var newValue = value;
        // manage a kind of `...` for the crop until this feature is implemented https://roadmap.meilisearch.com/c/69-policy-for-cropped-values?utm_medium=social&utm_source=portal_share
        // `...` is put if we are at the middle of a sentence (instead at the middle of the document field)
        if (snippetEllipsisText !== undefined && isString(newValue) && newValue) {
            if (newValue[0] === newValue[0].toLowerCase() && // beginning of a sentence
                newValue.startsWith('<em>') === false // beginning of the document field, otherwise MeiliSearch would crop around the highligh
            ) {
                newValue = "" + snippetEllipsisText + newValue;
            }
            if (!!newValue.match(/[.!?]$/) === false) {
                // end of the sentence
                newValue = "" + newValue + snippetEllipsisText;
            }
        }
        return replaceHighlightTags(newValue, highlightPreTag, highlightPostTag);
    }
    /**
     * @param  {Record<string} formattedHit
     * @param  {readonlystring[]|undefined} attributesToSnippet
     * @param  {string|undefined} snippetEllipsisText
     * @param  {string|undefined} highlightPreTag
     * @param  {string|undefined} highlightPostTag
     */
    function adaptSnippet(formattedHit, attributesToSnippet, snippetEllipsisText, highlightPreTag, highlightPostTag) {
        if (attributesToSnippet === undefined) {
            return null;
        }
        attributesToSnippet = attributesToSnippet.map(function (attribute) { return attribute.split(':')[0]; });
        // formattedHit is the `_formatted` object returned by MeiliSearch.
        // It contains all the highlighted and croped attributes
        return Object.keys(formattedHit).reduce(function (result, key) {
            if (attributesToSnippet === null || attributesToSnippet === void 0 ? void 0 : attributesToSnippet.includes(key)) {
                result[key] = {
                    value: snippetValue(formattedHit[key], snippetEllipsisText, highlightPreTag, highlightPostTag),
                };
            }
            return result;
        }, {});
    }
    /**
     * Adapt MeiliSearch formating to formating compliant with instantsearch.js.
     *
     * @param  {Record<string} formattedHit
     * @param  {InstantSearchParams} instantSearchParams
     * @returns Record
     */
    function adaptFormating(formattedHit, instantSearchParams) {
        var attributesToSnippet = instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.attributesToSnippet;
        var snippetEllipsisText = instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.snippetEllipsisText;
        var highlightPreTag = instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.highlightPreTag;
        var highlightPostTag = instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.highlightPostTag;
        if (!formattedHit || formattedHit.length)
            return {};
        return {
            _highlightResult: adaptHighlight(formattedHit, highlightPreTag, highlightPostTag),
            _snippetResult: adaptSnippet(formattedHit, attributesToSnippet, snippetEllipsisText, highlightPreTag, highlightPostTag),
        };
    }

    /**
     * @param  {Array<Record<string} meiliSearchHits
     * @param  {InstantSearchParams} instantSearchParams
     * @param  {SearchContext} instantMeiliSearchContext
     * @returns any
     */
    function adaptHits(meiliSearchHits, instantSearchParams, instantMeiliSearchContext) {
        var primaryKey = instantMeiliSearchContext.primaryKey;
        var page = instantMeiliSearchContext.page, hitsPerPage = instantMeiliSearchContext.hitsPerPage;
        var paginatedHits = adaptPagination(meiliSearchHits, page, hitsPerPage);
        return paginatedHits.map(function (hit) {
            // Creates Hit object compliant with InstantSearch
            if (Object.keys(hit).length > 0) {
                var formattedHit = hit._formatted; hit._matchesInfo; var restOfHit = __rest(hit, ["_formatted", "_matchesInfo"]);
                return __assign(__assign(__assign({}, restOfHit), adaptFormating(formattedHit, instantSearchParams)), (primaryKey && { objectID: hit[primaryKey] }));
            }
            return hit;
        });
    }

    /**
     * Adapt search response from MeiliSearch
     * to search response compliant with instantsearch.js
     *
     * @param  {string} indexUid
     * @param  {MeiliSearchResponse<Record<string} searchResponse
     * @param  {InstantSearchParams} instantSearchParams
     * @param  {SearchContext} instantMeiliSearchContext
     * @returns Array
     */
    function adaptSearchResponse(indexUid, searchResponse, instantSearchParams, instantMeiliSearchContext) {
        var searchResponseOptionals = {};
        var facets = searchResponse.facetsDistribution;
        var exhaustiveFacetsCount = searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.exhaustiveFacetsCount;
        if (exhaustiveFacetsCount) {
            searchResponseOptionals.exhaustiveFacetsCount = exhaustiveFacetsCount;
        }
        var hits = adaptHits(searchResponse.hits, instantSearchParams, instantMeiliSearchContext);
        var nbPages = ceiledDivision(searchResponse.hits.length, instantMeiliSearchContext.hitsPerPage);
        var exhaustiveNbHits = searchResponse.exhaustiveNbHits;
        var nbHits = searchResponse.nbHits;
        var processingTimeMs = searchResponse.processingTimeMs;
        var query = searchResponse.query;
        var hitsPerPage = instantMeiliSearchContext.hitsPerPage, page = instantMeiliSearchContext.page;
        // Create response object compliant with InstantSearch
        var adaptedSearchResponse = __assign({ index: indexUid, hitsPerPage: hitsPerPage, page: page, facets: facets, nbPages: nbPages, exhaustiveNbHits: exhaustiveNbHits, nbHits: nbHits, processingTimeMS: processingTimeMs, query: query, hits: hits, params: '' }, searchResponseOptionals);
        return {
            results: [adaptedSearchResponse],
        };
    }

    /**
     * Adapt MeiliSearch facetsDistribution to instantsearch.js facetsDistribution
     * by completing the list of distribution with the facets that are checked in the components.
     *
     * To be aware of which field are checked a cache is provided that was made prior of the search request.
     *
     * @param  {Cache} cache?
     * @param  {FacetsDistribution} distribution?
     * @returns FacetsDistribution
     */
    function facetsDistributionAdapter(cache, distribution) {
        distribution = distribution || {};
        if (cache && Object.keys(cache).length > 0) {
            for (var cachedFacet in cache) {
                for (var _i = 0, _a = cache[cachedFacet]; _i < _a.length; _i++) {
                    var cachedField = _a[_i];
                    // if cached field is not present in the returned distribution
                    if (!distribution[cachedFacet] ||
                        !Object.keys(distribution[cachedFacet]).includes(cachedField)) {
                        // add 0 value
                        distribution[cachedFacet] = distribution[cachedFacet] || {};
                        distribution[cachedFacet][cachedField] = 0;
                    }
                }
            }
        }
        return distribution;
    }

    /**
     * @param  {string} filter
     */
    var adaptFilterSyntax = function (filter) {
        var matches = filter.match(/([^=]*)="?([^\\"]*)"?$/);
        if (matches) {
            matches[0]; var filterName = matches[1], value = matches[2];
            return [{ filterName: filterName, value: value }];
        }
        return [undefined];
    };
    /**
     * @param  {Filter} filters?
     * @returns Array
     */
    function extractFilters(filters) {
        if (typeof filters === 'string') {
            return adaptFilterSyntax(filters);
        }
        else if (Array.isArray(filters)) {
            return filters
                .map(function (nestedFilter) {
                if (Array.isArray(nestedFilter)) {
                    return nestedFilter.map(function (filter) { return adaptFilterSyntax(filter); });
                }
                return adaptFilterSyntax(nestedFilter);
            })
                .flat(2);
        }
        return [undefined];
    }
    /**
     * @param  {Filter} filters?
     * @returns Cache
     */
    function cacheFilters(filters) {
        var extractedFilters = extractFilters(filters);
        var cleanFilters = removeUndefined(extractedFilters);
        return cleanFilters.reduce(function (cache, parsedFilter) {
            var _a;
            var filterName = parsedFilter.filterName, value = parsedFilter.value;
            var prevFields = cache[filterName] || [];
            cache = __assign(__assign({}, cache), (_a = {}, _a[filterName] = __spreadArray(__spreadArray([], prevFields, true), [value]), _a));
            return cache;
        }, {});
    }

    /**
     * Create search context.
     *
     * @param  {string} indexName
     * @param  {InstantSearchParams} params
     * @param  {InstantMeiliSearchOptions={}} meiliSearchOptions
     * @param  {MeiliSearch} MeiliSearchClient
     * @returns SearchContext
     */
    function createContext(indexName, params, meiliSearchOptions, MeiliSearchClient) {
        if (meiliSearchOptions === void 0) { meiliSearchOptions = {}; }
        var paginationTotalHits = meiliSearchOptions.paginationTotalHits, primaryKey = meiliSearchOptions.primaryKey, placeholderSearch = meiliSearchOptions.placeholderSearch;
        var page = params === null || params === void 0 ? void 0 : params.page;
        var hitsPerPage = params === null || params === void 0 ? void 0 : params.hitsPerPage;
        var query = params === null || params === void 0 ? void 0 : params.query;
        // Split index name and possible sorting rules
        var _a = indexName.split(':'), indexUid = _a[0], sortByArray = _a.slice(1);
        var context = {
            client: MeiliSearchClient,
            indexUid: indexUid,
            paginationTotalHits: paginationTotalHits || 200,
            primaryKey: primaryKey || undefined,
            placeholderSearch: placeholderSearch !== false,
            hitsPerPage: hitsPerPage === undefined ? 20 : hitsPerPage,
            page: page || 0,
            sort: sortByArray.join(':') || '',
            query: query,
        };
        return context;
    }
    /**
     * Instanciate SearchClient required by instantsearch.js.
     *
     * @param  {string} hostUrl
     * @param  {string} apiKey
     * @param  {InstantMeiliSearchOptions={}} meiliSearchOptions
     * @returns InstantMeiliSearchInstance
     */
    function instantMeiliSearch(hostUrl, apiKey, meiliSearchOptions) {
        if (meiliSearchOptions === void 0) { meiliSearchOptions = {}; }
        return {
            MeiliSearchClient: new meilisearch_umd.MeiliSearch({ host: hostUrl, apiKey: apiKey }),
            search: function (instantSearchRequests
            // options?: RequestOptions & MultipleQueriesOptions - When is this used ?
            ) {
                return __awaiter(this, void 0, void 0, function () {
                    var searchRequest, instantSearchParams, context, adaptedSearchRequest, cachedFacet, searchResponse, adaptedSearchResponse, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                searchRequest = instantSearchRequests[0];
                                instantSearchParams = searchRequest.params;
                                context = createContext(searchRequest.indexName, instantSearchParams, meiliSearchOptions, this.MeiliSearchClient);
                                adaptedSearchRequest = adaptSearchRequest(instantSearchParams, context.paginationTotalHits, context.placeholderSearch, context.sort, context.query);
                                cachedFacet = cacheFilters(adaptedSearchRequest === null || adaptedSearchRequest === void 0 ? void 0 : adaptedSearchRequest.filter);
                                return [4 /*yield*/, context.client
                                        .index(context.indexUid)
                                        .search(context.query, adaptedSearchRequest)
                                    // Add the checked facet attributes in facetsDistribution and give them a value of 0
                                ];
                            case 1:
                                searchResponse = _a.sent();
                                // Add the checked facet attributes in facetsDistribution and give them a value of 0
                                searchResponse.facetsDistribution = facetsDistributionAdapter(cachedFacet, searchResponse.facetsDistribution);
                                adaptedSearchResponse = adaptSearchResponse(context.indexUid, searchResponse, instantSearchParams, context);
                                return [2 /*return*/, adaptedSearchResponse];
                            case 2:
                                e_1 = _a.sent();
                                console.error(e_1);
                                throw new Error(e_1);
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
            searchForFacetValues: function (_) {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    reject(new Error('SearchForFacetValues is not compatible with MeiliSearch'));
                                    resolve([]); // added here to avoid compilation error
                                })];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            },
        };
    }

    exports.adaptFormating = adaptFormating;
    exports.adaptHits = adaptHits;
    exports.adaptPagination = adaptPagination;
    exports.adaptSearchRequest = adaptSearchRequest;
    exports.adaptSearchResponse = adaptSearchResponse;
    exports.facetsDistributionAdapter = facetsDistributionAdapter;
    exports.instantMeiliSearch = instantMeiliSearch;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
